import React from 'react';
import { FileIcon } from '@make-software/cspr-design';
import { useTranslation } from 'react-i18next';
import { ACTIVITY_EXPORT_PATH } from '../../../router/paths';
import { useCustomHistory } from '../../../router/navigation';
import { buildRouterPath } from '../../../router/utils';
import { AccountMenuItem } from '@make-software/csprclick-ui';

export const AccountActivityExportMenuItem = () => {
  const { t } = useTranslation();
  const history = useCustomHistory();

  const redirectToActivityExportPage = () => {
    history.push(buildRouterPath(ACTIVITY_EXPORT_PATH, undefined, undefined), {
      allowedGoBack: false,
    });
  };

  return (
    <AccountMenuItem
      label={t('Activity Export')}
      onClick={redirectToActivityExportPage}
      icon={FileIcon}
    />
  );
};
